<template>
      <a id="brand_link" href="https://www.germanchatterbox.com" :title=version_info >
        <img src="/img/chatterboxbanner7.png" height="100%" >
      </a>
</template>

<script>
    export default {
        name: "MsgHeader",
        props: {
            title: String,
            subtitle: String,
          version_info: String
        }
    }
</script>

<style scoped>
h1 {
    margin: 0;
    padding: 0.5rem;
    font-size: 1.5rem
}
 p {
        font-size: 1.2rem
 }
#brand_link img {
      height: 100%;
}
#brand_link {
  display: block;
  max-height: 20px;
  min-height: 20px;
  width: 100%;
  border-bottom: 5px solid #039be5;
  background-color: red;
  }
</style>
